import { RefreshTokenException } from '@/domain/authenticating/authorization/exception/RefreshTokenException'

export class InvalidTokenException extends RefreshTokenException {

}
